export const imagelist = [
    "https://f005.backblazeb2.com/file/joyphotos/360_F_92535664_IvFsQeHjBzfE6sD4VHdO8u5OHUSc6yHF.jpg",
    "https://f005.backblazeb2.com/file/joyphotos/stock-photo-the-word-example-is-written-on-a-magnifying-glass-on-a-yellow-background-1883859943.jpg",
]